import clsx from 'clsx';
import Text from '@/components/Text/Text';
import styles from './LaunchOffer.module.scss';
// import Img from '@/components/Img';
import Button, { ButtonType } from '@/components/Button/Button';
import { mediaPath } from '@/mediaPath';
import Icon from '@/components/Icon';

export interface LaunchOfferProps {
  title: string;
  subtitle?: string;
  button?: {
    id: number;
    title: string;
    type: ButtonType;
    link: string;
    iconName?: string;
  };
  cards: {
    id: number;
    title: string | null;
    description: string | null;
    features: {
      id: number;
      title: string | null;
      list: {
        id: number;
        text: string | null;
      }[];
    } | null;
  }[];
  background: {
    url: string;
    alt: string;
  } | null;
  termsText?: string;
  withoutTopPadding?: boolean;
}

const LaunchOffer = ({ data, withoutTopPadding }: { data: LaunchOfferProps, withoutTopPadding?: boolean }) => (
  <section
    className={clsx(styles.launchOfferWrapper, {
      [styles.dark]: data.background?.url,
      [styles.withoutTopPadding]: withoutTopPadding,
    })}
  >
    <section
      className={clsx(styles.launchOffer, {
        [styles.dark]: data.background?.url,
      })}
      style={data.background?.url ? {
        // linear-gradient(0deg, rgba(255,255,255,0.7), rgba(255,255,255,0.7)),
        // linear-gradient(0deg, rgba(250,248,245,0.72) 0.2%, rgba(207,177,162,0) 99.83%),
        background: `
        linear-gradient(210deg, rgba(0,0,0,0) -3.27%, rgba(0,0,0,0.5) 41.64%), url(${
          mediaPath(data.background.url)
        }) lightgray 50% / cover no-repeat`,
      } : undefined}
    >
      <div className={styles.content}>
        <div className={styles.titleContainer}>
          <Text
            tag='h4'
            className={styles.title}
          >
            {data.title}
          </Text>
          {data.subtitle && (
          <Text
            tag='p'
            className={styles.subtitle}
            isSemiBold
          >
            {data.subtitle}
          </Text>
          )}
        </div>

        <ul className={styles.cards_list}>
          {data.cards.map((card) => (
            <li
              className={styles.cards_item}
              key={card.id}
            >
              {card.title && (
                <Text
                  tag='p'
                  className={styles.cardsTitle}
                >
                  {card.title}
                </Text>
              )}
              {card.description && (
                <Text
                  tag='p'
                  className={styles.cardsDescription}
                >
                  {card.description}
                </Text>
              )}
              {card.features?.title && (
                <Text
                  tag='p'
                  className={styles.cardsTitle}
                >
                  {card.features.title}
                </Text>
              )}
              {card.features?.list?.length ? (
                <ul className={styles.featuresList}>
                  {card.features.list.map((feature) => (
                    <li
                      key={feature.id}
                      className={styles.featuresItem}
                    >
                      <Icon
                        name='check'
                        style={{ fontSize: 24, alignSelf: 'flex-start', fontWeight: 700 }}
                        aria-hidden
                      />
                      <span>{feature.text}</span>
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          ))}
        </ul>
        {data.button && (
        <div className={styles.primaryButtonContainer}>
          <Button
            type={data.button.type}
            href={data.button.link}
            iconName={data.button.iconName}
          >
            {data.button.title}
          </Button>
        </div>
        )}
      </div>
    </section>
    {data.termsText && (
      <Text
        tag='p'
        className={styles.termsText}
      >
        {data.termsText}
      </Text>
    )}
  </section>
);

export default LaunchOffer;
